import type { ProductHit } from '@libs/algolia';
import {
    ALGOLIA_PERSISTANT_PRODUCT_FILTERS,
    AlgoliaIndice,
    getProductById,
    getSearchIndex,
} from '@libs/algolia';
import apiProxyClient from '@libs/api-proxy-client';
import type { Inventory } from '@libs/common-node';
import { localizedWebInventory } from '@libs/ocapi';

const getInventoryQuantity = (
    inventories: Inventory[],
    key: string,
    objectID: string,
    isSKUAvailable: boolean | undefined
) => {
    const inventory = inventories?.find(
        (inv: Inventory) => `${inv?.sku}` === objectID
    );
    const quantity = inventory?.[key] ?? 0;

    return isSKUAvailable && typeof quantity === 'number' && quantity > 0;
};

export const getBestSellerVariant = async (
    masterProductID: string
): Promise<ProductHit> => {
    try {
        const index = getSearchIndex(AlgoliaIndice.PRODUCTS_BEST_SELLERS);
        if (masterProductID.length > 5) {
            return getProductById(masterProductID) as unknown as ProductHit;
        }
        const masterIdFilter = `masterProductID = ${masterProductID}`;
        const response = await index.search<ProductHit>('', {
            filters: `(${ALGOLIA_PERSISTANT_PRODUCT_FILTERS}) AND (${masterIdFilter})`,
            distinct: 0,
        });

        if (response.hits && response.hits.length > 0) {
            const ids = response.hits.map(hit => hit.objectID);
            const [bestSeller, ...restVariants] = response.hits;

            if (bestSeller.isSKUAvailable) {
                return bestSeller;
            }
            if (restVariants.length > 0) {
                const storesku = ids.map(sku => ({
                    sku: `${sku}`,
                    store: `${localizedWebInventory}`,
                }));
                const inventory =
                    await apiProxyClient.inventory.getProductInventoryPairs(
                        storesku
                    );

                const avaiableBestSeller = restVariants.find(variant =>
                    getInventoryQuantity(
                        inventory,
                        localizedWebInventory,
                        variant.objectID,
                        variant?.isSKUAvailable
                    )
                );

                if (avaiableBestSeller) {
                    return avaiableBestSeller;
                }
            }
        }
        return response.hits[0];
    } catch (error) {
        console.error('[algolia/getMultipleObjectsById]', error);
        return {} as ProductHit;
    }
};
